"use strict";module.exports = require("@internal/components-registry");